var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckInWithPinDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10556_11",
    "data-name": "Group 10556 11",
    transform: "translate(-140 -1010)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6850",
    "data-name": "Rectangle 6850",
    width: 40,
    height: 40,
    rx: 5,
    ry: 5,
    transform: "translate(140 1010)",
    fill: "#24435f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Scanner",
    transform: "translate(145.5 1020)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Check-in_PIN",
    "data-name": "Check-in PIN",
    d: "M14924-14793a3,3,0,0,1-3-3v-14a3,3,0,0,1,3-3h24a3,3,0,0,1,3,3v14a3,3,0,0,1-3,3Zm-1-17v14a1,1,0,0,0,1,1h24a1,1,0,0,0,1-1v-14a1,1,0,0,0-1-1h-24A1,1,0,0,0,14923-14810Zm20.029,8.488-.866,1.512-1.31-.758.855-1.509H14940v-1.512h1.711l-.855-1.46,1.31-.762.866,1.464.855-1.464,1.3.762-.858,1.46h1.722v1.512h-1.722l.858,1.509-1.3.758Zm-6.945,0-.855,1.512-1.313-.758.855-1.509h-1.707v-1.512h1.707l-.855-1.46,1.313-.762.855,1.464.859-1.464,1.313.762-.867,1.46h1.723v1.512h-1.723l.867,1.509-1.313.758Zm-7.054,0-.863,1.512-1.313-.758.859-1.509H14926v-1.512h1.715l-.859-1.46,1.313-.762.863,1.464.855-1.464,1.3.762-.855,1.46h1.719v1.512h-1.719l.855,1.509-1.3.758Z",
    transform: "translate(-14921.001 14813.001)",
    fill: "#fff",
    opacity: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInWithPinDark);
export default __webpack_public_path__ + "static/media/CheckInWithPinDark.b1930c1ff39a8bddfd3b9ecf6c0a2001.svg";
export { ForwardRef as ReactComponent };